import FileUploads from './components/FileUploads'
import fileUploadsReducer from './reducers'
import * as fileUploadsActions from './actions'
import * as fileUploadsSelectors from './selectors'

export default FileUploads

export { FileUploads, fileUploadsReducer, fileUploadsActions, fileUploadsSelectors }
